import React, { Fragment } from "react";
import { fetchPrizeAmount, fetchPrizeText, pluckYearArray } from "../utils";
import TrophyGradient from "shared/ui/svg-icons/Leaderboard/Desktop/TrophyGradient";
import TrophyStatsDivider from "shared/ui/svg-icons/Leaderboard/Desktop/TrophyStatsDivider";
import { FormattedNumber } from "react-intl";

const TrophyCard = ({ currencyCode, data, placeData, trophyHeaders, Trophy }) => (
  <Fragment>
    {placeData && (
      <div className="card-container">
        <div className="ellipse">
          <img src={placeData.image} aria-hidden="true" width="80" />
        </div>
        <div className="card">
          <div className="card-header">
            <TrophyGradient />
          </div>
          <Trophy />

          <div className="content">
            <div className="title">{placeData.display_title}</div>
            <div className="card-header centered">
              <div className="prize-text">{fetchPrizeText(data)}</div>
              <div className="prize-amount">
                <FormattedNumber
                  value={fetchPrizeAmount(placeData)}
                  currencyDisplay="symbol"
                  currency={currencyCode}
                  style="currency"
                />
              </div>
            </div>
            <div className="card-header year-content flex">
              {trophyHeaders.map((header, index) => (
                <Fragment key={index}>
                  <span className="flex-item">
                    <span className="trophy-heading">{header}</span>
                    <span className="trophy-data">
                      {pluckYearArray(placeData)[index]}
                    </span>
                  </span>
                  <TrophyStatsDivider className="trophy-spacer" />
                </Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    )}
  </Fragment>
);

export default TrophyCard;
